/**
 * @flow
 */

import React, { useMemo } from 'react';
import { property, chain } from 'lodash';

import { Select } from '../../../../components';

const mapCabinets = cabinets =>
    chain(cabinets)
        .uniqBy(property('id'))
        .map(cabinet => ({
            key: cabinet.id,
            value: cabinet.id,
            text: cabinet.name,
        }))
        .filter(property('value'))
        .value();

// `meta`/`dispatch`/`change` (redux-form leftovers) and the raw `cabinets`
// list are stripped so they don't leak onto the underlying Select.
const CabinetSelect = ({ meta, dispatch, cabinets, change, ...props }) => {
    const options = useMemo(() => mapCabinets(cabinets), [cabinets]);
    return <Select {...props} options={options} />;
};

export default CabinetSelect;
